import React, { useEffect, useState } from "react";
import "./RelativeMapHover.css";
import { useStateValue } from "../../utils/Provider/StateProvider";
import RelativeHintAdditionModal from "../ModalComponent/RelativeHintAdditionModal";

function RelativeMapHover({ relation, children }) {
  const [{ mapRelativeDesc }, dispatch] = useStateValue();

  const [relativeKey, setRelativeKey] = useState();
  const [openRelativeMapModal, setOpenRelativeMapModal] = useState(false);

  useEffect(() => {
    const temp = {};
    mapRelativeDesc &&
      mapRelativeDesc.forEach((obj) => {
        Object.keys(obj).forEach((i) => {
          temp[i] = obj[i];
        });
      });

    console.log(temp, relation, temp[relation]);
    setRelativeKey(temp);
  }, [mapRelativeDesc]);

  return (
    <div className="relativemap_container">
      <div className="relativemap_childrens">{children}</div>

      <div className="relativemap_details_div">
        <p>
          {relativeKey && relativeKey.hasOwnProperty(relation.toLowerCase()) ? (
            relativeKey[relation.toLowerCase()]
          ) : (
            <div>
              <p
                className="add_relative_map_directly"
                onClick={() => setOpenRelativeMapModal(true)}
              >
                Add description of this relation &nbsp;&nbsp; +
              </p>
            </div>
          )}
        </p>
      </div>

      {openRelativeMapModal && (
        <RelativeHintAdditionModal
          title="Describe the relative category !"
          onCloseHandler={() => setOpenRelativeMapModal(false)}
          defaultKey={relation}
        />
      )}
    </div>
  );
}

export default RelativeMapHover;
